@if (footer) {
    <sirius-container>
        <div class="footer-inner sir-text-style-paragraph-m-default">
            <div class="footer-brand" data-cy="company-logo">
                <img src="assets/footer-logo.svg" alt="Universal Robots" />
            </div>

            <div class="footer-body">
                <section class="footer-contact" aria-labelledby="footer-contact-heading">
                    <sirius-heading
                        class="footer-heading"
                        [id]="'footer-contact-heading'"
                        [h]="2"
                        [text]="'footer.localOffice' | translate"
                        textStyleSize="s"
                        textStyleCategory="title">
                    </sirius-heading>
                    @if (companyInfo) {
                        <address class="footer-address" data-cy="company-info">
                            <div class="footer-address-field" data-cy="company-address">
                                <sirius-icon [name]="'map_pin_duotone'" aria-hidden="true"></sirius-icon>
                                <span>
                                    {{ companyInfo.address.name }}<br />
                                    {{ companyInfo.address.street1 }}<br />
                                    {{ companyInfo.address.postalCode }}
                                    {{ companyInfo.address.city }}
                                </span>
                            </div>
                            @for (phoneNumber of companyInfo.phoneNumbers; track $index) {
                                <div class="footer-address-field" data-cy="company-phone-numbers">
                                    <sirius-icon [name]="'headset_duotone'" aria-hidden="true"></sirius-icon>
                                    <span>
                                        {{ phoneNumber.phoneNumberLabel }}:
                                        <a
                                            [href]="phoneNumber.phoneNumber.href"
                                            (click)="onClick({ link: phoneNumber.phoneNumber, event: $event })"
                                            >{{ phoneNumber.phoneNumber.title }}</a
                                        >
                                    </span>
                                </div>
                            }
                            <div class="footer-address-field" data-cy="company-email">
                                <sirius-icon [name]="'telegram_logo_duotone'" aria-hidden="true"></sirius-icon>
                                <a
                                    [href]="companyInfo.email.href"
                                    (click)="onClick({ link: companyInfo.email, event: $event })"
                                    >{{ companyInfo.email.title }}</a
                                >
                            </div>
                        </address>
                    }
                </section>

                <nav class="footer-nav" aria-label="Footer navigation">
                    @for (group of footer.menuGroups; track $index; let groupIndex = $index) {
                        <sirius-heading
                            class="footer-heading"
                            [id]="'footer-nav-heading-' + groupIndex"
                            [h]="2"
                            [text]="group.heading.text"
                            textStyleCategory="title"
                            textStyleSize="s">
                        </sirius-heading>
                        <ul class="footer-nav-list" [attr.aria-labelledby]="'footer-nav-heading-' + groupIndex">
                            @for (item of group.items; track $index) {
                                <li>
                                    <a [siriusLink]="item.link" (linkSelect)="onClick({ link: item.link, event: $event })"
                                        >{{ item.link.title
                                        }}<sirius-icon [name]="'arrow_right_small'" aria-hidden="true"></sirius-icon
                                    ></a>
                                </li>
                            }
                        </ul>
                    }
                </nav>
            </div>

            <div class="footer-meta">
                <nav class="footer-social" aria-label="Social media">
                    <ul class="footer-social-list">
                        @for (soMeLink of socialMediaLinks; track $index) {
                            @if (soMeLink.icon) {
                                <li>
                                    <a
                                        [siriusLink]="soMeLink.link"
                                        [attr.aria-label]="soMeLink.link.title || soMeLink.link.href"
                                        (linkSelect)="onClick({ link: soMeLink.link, event: $event })">
                                        <sirius-icon [name]="soMeLink.icon" aria-hidden="true"></sirius-icon>
                                    </a>
                                </li>
                            }
                        }
                    </ul>
                </nav>
                <div class="footer-legal">
                    <p class="footer-copyright">&copy; {{ currentYear }} Universal Robots A/S</p>
                    <nav class="footer-legal-nav" aria-label="Legal">
                        <ul class="footer-legal-list">
                            @for (legalLink of footer.legalLinks; track legalLink.link.href; let i = $index) {
                                <li>
                                    <a
                                        [psbButton]="isChina && i === 0"
                                        [siriusLink]="legalLink.link"
                                        (linkSelect)="onClick({ link: legalLink.link, event: $event })"
                                        >{{ legalLink.link.title }}</a
                                    >
                                </li>
                            }
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </sirius-container>
}
